export var getVersionBrowserColoringClass = function (coloring) {
    if (!coloring) {
        return '';
    }
    return "revisionColoring revisionColoring--" + coloring.toLowerCase();
};
export var getColoringArgType = function () { return ({
    control: {
        type: 'select',
        options: [
            'RED',
            'GREEN',
            'TRANSPARENT',
            undefined
        ]
    }
}); };
//# sourceMappingURL=utils.js.map